module.exports = __webpack_public_path__ + "img/itel_qr.90e21eee.png";